import {Controller} from '@hotwired/stimulus';

/**
 * Pose la classe d'animation sur l'élément à chaque clic et la retire après `duration` millisecondes,
 * le temps que l'animation CSS qu'elle déclenche se joue. Le clic garde son effet (un lien est suivi).
 *
 *   <a href="…" class="btn btn-primary confetti-button"
 *      {{ stimulus_controller('animate-on-click', {}, {animation: 'animate'}) }}
 *      {{ stimulus_action('animate-on-click', 'play') }}>…</a>
 */
export default class extends Controller {
  static classes = ['animation'];
  static values = {duration: {type: Number, default: 700}};

  play() {
    this.element.classList.add(this.animationClass);
    setTimeout(() => this.element.classList.remove(this.animationClass), this.durationValue);
  }
}
